import { DOCUMENTS } from 'projects/common/models/main';

const boxes: string[] = ['pallet', 'box', 'crate', 'sack', 'bottle', 'drum', 'bundle'];
const air_containers: string[] = ['ld', 'ake', 'ave', 'ld9', 'palletP1P', 'palletP6', 'palletPGA', 'reefer'];
const other_containers: string[] = ['inches20', 'inches40', 'flatRack', 'highCube', 'openSide', 'openTop', 'reefer', 'tank', 'pallet'];
const trailer_types: string[] = ['semiTrailer', 'tarpaulin', 'refrigerated', 'capitonne', 'gondola', 'platform', 'tanker', 'carCarrier', 'containerCarrier'];
const documents: string[] = Object.values(DOCUMENTS);

export default { boxes, air_containers, other_containers, trailer_types, documents };
